import { PaymentCollectionType } from '@features/group-management/constants';
import { getFeeCategoryData } from '@features/group-management/helper';
import { FormDataType } from '@types';
import { formatISODate } from '@utils/date';

// eslint-disable-next-line import/prefer-default-export
export const getUpdateGroupAnalyticParams = (
  groupDetails: FormDataType,
  isFeeCategoryEnabled: boolean,
  feeCategories: any
) => ({
  amount: groupDetails.amount,
  name: groupDetails.groupName,
  is_split_payment: groupDetails.paymentInstallment,
  end_date: groupDetails.endDate
    ? formatISODate({
        date: groupDetails.endDate,
        separator: '-',
        format: 'yyyy-mm-dd'
      })
    : null,
  interval:
    groupDetails.paymentCollectionType === PaymentCollectionType.WEEKLY
      ? PaymentCollectionType.WEEKLY
      : PaymentCollectionType.MONTHLY,
  interval_frequency: Number(groupDetails.intervalFrequency),
  is_attendance_tracking_enabled: groupDetails.isAttandanceTrackingEnabled,
  ...(groupDetails.isAttandanceTrackingEnabled && {
    is_send_attendance_alert_enabled: groupDetails.isSendAttendanceAlertEnabled
  }),
  working_days: groupDetails?.workingDays,
  activation_date: formatISODate({
    date: groupDetails.nextDueAt || '',
    separator: '-',
    format: 'yyyy-mm-dd'
  }),
  ...(isFeeCategoryEnabled && {
    group_fee_configuration: getFeeCategoryData(feeCategories)
  }),
  is_fee_configured: isFeeCategoryEnabled
});
